"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchLoupeIcon16Light = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.SearchLoupeIcon16Light = forwardRef_1.forwardRef('SearchLoupeIcon16Light', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 16 }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.5 1.751a5.749 5.749 0 1 0 3.696 10.152l2.706 2.705a.5.5 0 1 0 .707-.707l-2.706-2.705A5.749 5.749 0 0 0 6.5 1.751ZM1.751 7.5a4.749 4.749 0 1 1 9.498 0 4.749 4.749 0 0 1-9.498 0Z" })));
});
